// extracted by mini-css-extract-plugin
module.exports = {"valores":"styles_valores__368C_","columns":"styles_columns__1uRq0"};